export default "__VITE_ASSET__2004e932__"